import ClientNavbar from "../../components/client/ClientNavbar";
import Footer from "../../components/client/Footer";

// src/pages/client/Support.jsx
const Support = () => {
  const supportOptions = [
    {
      title: "Centre d'Aide",
      description: "Consultez notre base de connaissances",
      icon: "📚",
      link: "/help-center"
    },
    {
      title: "Chat en Direct",
      description: "Discutez avec notre équipe support",
      icon: "💬",
      link: "/live-chat"
    },
    {
      title: "Email Support",
      description: "Envoyez-nous votre question",
      icon: "📧",
      link: "mailto:florian@jobrise.tech"
    },
    {
      title: "Planifier un Appel",
      description: "Réservez un créneau avec un expert",
      icon: "📞",
      link: "/schedule-call"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <ClientNavbar />
      
      {/* Hero Section */}
      <div className="pt-20 pb-16 bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-6">
            Support Client
          </h1>
          <p className="text-xl text-emerald-100 mb-8 max-w-3xl mx-auto">
            Notre équipe est là pour vous aider à tirer le meilleur parti de Jobrise
          </p>
          <div className="bg-white bg-opacity-20 rounded-lg p-6 max-w-md mx-auto">
            <p className="text-white mb-2">Temps de réponse moyen</p>
            <p className="text-3xl font-bold text-white">Moins de 2 heures</p>
          </div>
        </div>
      </div>

      {/* Support Options */}
      <div className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-800 mb-4">
              Comment Pouvons-nous Vous Aider ?
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Choisissez le canal de support qui vous convient le mieux
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {supportOptions.map((option, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition text-center">
                <div className="text-4xl mb-4">{option.icon}</div>
                <h3 className="text-xl font-semibold mb-3">{option.title}</h3>
                <p className="text-slate-600 mb-6">{option.description}</p>
                <button className="bg-emerald-600 text-white px-6 py-2 rounded-lg hover:bg-emerald-700 transition w-full">
                  Accéder
                </button>
              </div>
            ))}
          </div>

          {/* FAQ Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-16">
            <h3 className="text-2xl font-bold text-center mb-8">Questions Fréquentes</h3>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold mb-2">Comment importer mes candidats existants ?</h4>
                  <p className="text-slate-600 text-sm">Vous pouvez importer vos candidats via notre extension LinkedIn ou en uploadant un fichier CSV depuis votre ancien système.</p>
                </div>
                <div>
                  <h4 className="font-semibold mb-2">Puis-je collaborer avec mon équipe ?</h4>
                  <p className="text-slate-600 text-sm">Oui, Jobrise permet de créer des espaces d'équipe avec différents niveaux d'accès et de permissions.</p>
                </div>
                <div>
                  <h4 className="font-semibold mb-2">Mes données sont-elles sécurisées ?</h4>
                  <p className="text-slate-600 text-sm">Absolument. Nous respectons le RGPD et utilisons un chiffrement de niveau bancaire pour protéger vos données.</p>
                </div>
              </div>
              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold mb-2">Comment fonctionne la facturation ?</h4>
                  <p className="text-slate-600 text-sm">Nous proposons des abonnements mensuels ou annuels avec une période d'essai gratuite de 14 jours.</p>
                </div>
                <div>
                  <h4 className="font-semibold mb-2">Puis-je personnaliser les processus de recrutement ?</h4>
                  <p className="text-slate-600 text-sm">Oui, vous pouvez créer des processus sur mesure avec autant d'étapes que nécessaire selon vos besoins.</p>
                </div>
                <div>
                  <h4 className="font-semibold mb-2">Y a-t-il une limite au nombre de candidats ?</h4>
                  <p className="text-slate-600 text-sm">Cela dépend de votre plan. Le plan Starter permet jusqu'à 1000 candidats, les plans supérieurs sont illimités.</p>
                </div>
              </div>
            </div>
            <div className="text-center mt-8">
              <button className="text-emerald-600 hover:text-emerald-700 font-medium">
                Voir toutes les FAQ →
              </button>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <h3 className="text-2xl font-bold text-center mb-8">Contactez-nous Directement</h3>
            <div className="max-w-2xl mx-auto">
              <form className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Prénom</label>
                    <input type="text" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Nom</label>
                    <input type="text" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Email</label>
                  <input type="email" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Sujet</label>
                  <select className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent">
                    <option>Question technique</option>
                    <option>Demande de fonctionnalité</option>
                    <option>Problème de facturation</option>
                    <option>Autre</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Message</label>
                  <textarea rows="5" className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent" placeholder="Décrivez votre question ou problème..."></textarea>
                </div>
                <div className="text-center">
                  <button type="submit" className="bg-emerald-600 text-white px-8 py-3 rounded-lg hover:bg-emerald-700 transition font-semibold">
                    Envoyer le Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer/>
    </div>
  );
};

export default Support;